import { DE } from './terms-of-use/DE.js';
import { UK } from './terms-of-use/UK.js';
import { EN } from './terms-of-use/EN.js';
export const termsOfUse = {
  en: EN,
  uk: UK,
  de: DE,
};
